import constate from 'constate';
import { useEffect } from 'react';
import { useEditorEvent } from '../hooks/useEditorEvent';
import { useEditorModals } from '../hooks/useEditorModals';
import { useEditor } from './EditorSdkProvider';

const useEditorToolsContext = () => {
  const editorSdk = useEditor();
  const editorTools = useEditorModals();

  useEditorEvent(editorSdk, 'startFindAndReplaceMode', editorTools.closeAll);
  useEditorEvent(editorSdk, 'startBlockInteractionsMode', editorTools.closeAll);
  useEditorEvent(editorSdk, 'startGuidanceTooltipsMode', editorTools.closeAll);
  useEditorEvent(
    editorSdk,
    'startPerformancePickSelectorMode',
    editorTools.closeAll
  );

  useEffect(() => {
    if (editorTools.isOpenAny) {
      editorSdk.stopFindAndReplaceMode();
      editorSdk.stopBlockInteractionsMode();
      editorSdk.stopGuidanceTooltipsMode();
    }
  }, [editorTools.isOpenAny]);

  return editorTools;
};

export const [EditorToolsProvider, useEditorTools] = constate(
  useEditorToolsContext
);
